export default "__VITE_ASSET__CEYuU9cR__"